import { StringDateTimeLeft } from '@/common/hooks/useCountdown/formatter/stringDateFormatter';

import styles from './upcomingCounter.module.scss';

interface UpcomingCounterContentProps {
  timeLeft: StringDateTimeLeft;
}

const UpcomingCounterContent = ({ timeLeft }: UpcomingCounterContentProps) => (
  <>
    <span className={styles.timeCell}>{timeLeft.hours}h</span>
    <span>:</span>
    <span className={styles.timeCell}>{timeLeft.minutes}m</span>
    <span>:</span>
    <span className={styles.timeCell}>{timeLeft.seconds}s</span>
  </>
);

export default UpcomingCounterContent;
